import _Object$assign from "babel-runtime/core-js/object/assign";
import _Promise from "babel-runtime/core-js/promise";
import storage from "../tools/storage";
import sysConfig from "../config/sysConfig";
import baseConfig from "../config/baseConfig";

var isWin = baseConfig.isWin;
var org = {
	getOrgData: function getOrgData(isSort) {

		return new _Promise(function (resolve, reject) {

			var cacheArr = storage.$storage.getJsonLocal("OrgData") || [];

			if (cacheArr.length) {
				resolve(cacheArr);
			} else {
				sysConfig.$syscfg.K_Request("YG000200").then(function (data) {

					var d = data.Data;

					cacheArr = false !== isSort ? _.chain(d).sortBy(function (v) {
						return parseInt(v.ORG_CODE);
					}).value() : d;

					storage.$storage.setLocal("OrgData", cacheArr);

					resolve(cacheArr);
				}).catch(function (err) {
					consoleLog(err);
					reject(err);
				});
			}
		});
	},

	transOrgCode: function transOrgCode(orgCode) {
		if (orgCode && orgCode.length < 4 && isWin) {
			var tmp = "0000" + orgCode;
			return tmp.substring(tmp.length - 4);
		} else {
			return orgCode;
		}
	},

	getOrgDataById: function getOrgDataById(orgCode, isSort, orgType) {
		return new _Promise(function (resolve, reject) {
			org.getOrgData(isSort).then(function (orgArr) {
				resolve(_.chain(orgArr).find(function (v) {
					return Number(v.ORG_CODE) === Number(orgCode) && (orgType ? v.ORG_TYPE == orgType : true);
				}).value() || {});
			});
		});
	},

	getOrgDataByType: function getOrgDataByType(orgType, isSort) {
		return new _Promise(function (resolve, reject) {
			org.getOrgData(isSort).then(function (orgArr) {
				resolve(_.chain(orgArr).filter(function (v) {
					return v.ORG_TYPE === orgType;
				}).value() || []);
			});
		});
	},

	transFormData: function transFormData(arg, codekey, orgType, shallow) {

		return new _Promise(function (resolve, reject) {

			var isArray = Array.isArray(arg),
			    orgCodeKey = codekey || "ORG_CODE",
			    data = shallow ? _Object$assign([], isArray ? arg : [arg]) : _.defaultsDeep([], isArray ? arg : [arg]);
			orgType = orgType || "0";
			org.getOrgData().then(function (orgData) {

				data.map(function (item) {
					var orgObj = void 0;
					if (!item[orgCodeKey]) {
						return true;
					}
					orgObj = _.chain(orgData).find(function (v) {
						return org.transOrgCode(v.ORG_CODE) === org.transOrgCode(item[orgCodeKey]) && v.ORG_TYPE === orgType;
					}).value();

					if (orgObj) {
						item[orgCodeKey + "_TEXT"] = orgObj.ORG_NAME;
					} else {
						item[orgCodeKey + "_TEXT"] = "";
					}
					return item;
				});

				resolve(isArray ? data : data[0]);
			});
		});
	}

};

export default org;


//////////////////
// WEBPACK FOOTER
// ./src/tools/org.js
// module id = 126
// module chunks = 2